import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';
import ConceptsBreakdown from 'components/PriceConceptsBreakdown/PriceConceptsBreakdown';

export default styled(ConceptsBreakdown)`
  min-width: 300px;

  .concepts-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    & > :last-child {
      border-bottom: 1px solid #e2e8ee;
      margin-bottom: 10px;
    }
  }

  .concept-item {
    align-items: center;
    padding: 14px 0;
    color: var(grey900);
    display: flex;
    line-height: normal;
    ${media.lessThan('large')`
      border-top: 1px solid #E2E8EE;
      padding: 20px 0 24px 20px;
    `}

    > :first-letter {
      text-transform: capitalize;
    }

    > div:first-child {
      flex: 1;
      margin-right: ${gridSizes('M')};
    }

    > div:last-child {
      white-space: nowrap;
    }

    span {
      margin-left: 6px;
    }

    &.withMargin {
      margin-top: ${gridSizes('M')};
    }

    .handling-tip {
      margin: 0;
      font-weight: bold;
    }

    .tag {
      margin: 0 0 0 1rem;
      line-height: 2.5;
      font-size: 1.2rem;
      line-height: 1.2rem;

      &.xdock {
        background-color: var(--deep-purple100);
        color: var(--deep-purple900);
        text-transform: lowercase;

        svg {
          margin-top: -0.2rem;
          fill: var(--deep-purple900);
        }
      }
      &.xdock-low-prio {
        background-color: var(--deep-purple900);
        color: var(--deep-purple100);
        text-transform: lowercase;

        svg {
          margin-top: -0.2rem;
          fill: var(--deep-purple100);
        }
      }

      &.green {
        background-color: var(--success100);
        color: var(--success900);
      }
    }
  }
`;
